import * as MuiIcons from '@mui/icons-material';
import { QuestionMark } from '@mui/icons-material';
import type { CellContext } from '@tanstack/react-table';
import { memo } from 'react';

interface Props<T, P> {
  value: string;
  row: CellContext<T, P>;
  onClick?: (row: T, cell: keyof P) => void;
  isClickable?: boolean;
}

const IconBase = <T, P>({ value, row, onClick, isClickable }: Props<T, P>) => {
  const IconComponent = MuiIcons[value as keyof typeof MuiIcons] || QuestionMark;

  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(row.row.original, row.column.id as keyof P);
    }
  };

  return <IconComponent className={`h-full max-h-6 w-auto ${isClickable ? 'cursor-pointer' : ''}`} onClick={handleClick} />;
};

export const Icon = memo(IconBase) as typeof IconBase;
